module.exports = __webpack_public_path__ + "sgby/img/up.612eeb1.png";